import CardSystem from '../CardSystem';
import GameObject from '../../../GameObject/GameObject';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { AnimationClipTask } from '../../../Utility/Task/AnimationClipTask';
import { CardPlusStreakJoker } from '../../Animation/Clip';
import Renderable from '../../../Component/Renderable';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';

export default function PlusStreakJokerCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData,
): void {
    const cards = taskData.cards.map((id) => system.getCardByID(id));
    const animator = GameObject.Instantiate(Animator);
    system.animator.addChild(animator);

    cards.forEach((card) => {
        card.getComponent(Renderable).visible = false;
    });

    const task = new AnimationClipTask(new CardPlusStreakJoker(animator, { system, cards }));

    StreakBar.instance
        .updatePromise(system.store.getState().levelState.cardsState.turns)
        .then(() => {
            system.taskQueue.queueNext(task);
            system.startTasks();
        });
}
